// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import { registerLazyControllers } from "./lazy_controllers"

import ActivityFormController from "./activity_form_controller"
application.register("activity-form", ActivityFormController)

import AdvocateCardListComponentController from "../../view_components/community_site/advocate_card_list_component_controller"
application.register("advocate-card-list-component", AdvocateCardListComponentController)

import AnchorHeadingController from "../../view_components/ui/typography/anchor_heading_controller"
application.register("anchor-heading", AnchorHeadingController)

import ApplicationFormStartedController from "./application_form_started_controller"
application.register("application-form-started", ApplicationFormStartedController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import BeatVisibilityController from "./beat_visibility_controller"
application.register("beat-visibility", BeatVisibilityController)

import BrowserTimeZoneController from "./browser_time_zone_controller"
application.register("browser-time-zone", BrowserTimeZoneController)

import CheckboxGroupController from "./checkbox_group_controller"
application.register("checkbox-group", CheckboxGroupController)

import ClaimLimitWindowController from "./claim_limit_window_controller"
application.register("claim-limit-window", ClaimLimitWindowController)

import ClearStorageController from "./clear_storage_controller"
application.register("clear-storage", ClearStorageController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import ColorInputController from "./color_input_controller"
application.register("color-input", ColorInputController)

import ComboboxFlipController from "./combobox_flip_controller"
application.register("combobox-flip", ComboboxFlipController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import CommandPaletteLauncherController from "./command_palette_launcher_controller"
application.register("command-palette-launcher", CommandPaletteLauncherController)

import ConditionalVisibilityController from "./conditional_visibility_controller"
application.register("conditional-visibility", ConditionalVisibilityController)

import ConsentBannerController from "./consent_banner_controller"
application.register("consent-banner", ConsentBannerController)

import CopyButtonController from "../../view_components/ui/copy_button_controller"
application.register("copy-button", CopyButtonController)

import DatetimeRangeController from "./datetime_range_controller"
application.register("datetime-range", DatetimeRangeController)

import DeploymentStatusController from "./deployment_status_controller"
application.register("deployment-status", DeploymentStatusController)

import DismissableBannerController from "./dismissable_banner_controller"
application.register("dismissable-banner", DismissableBannerController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import FileDropzoneController from "./file_dropzone_controller"
application.register("file-dropzone", FileDropzoneController)

import FillComposerController from "./fill_composer_controller"
application.register("fill-composer", FillComposerController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import GlobalShortcutsController from "./global_shortcuts_controller"
application.register("global-shortcuts", GlobalShortcutsController)

import HotkeySubmitController from "./hotkey_submit_controller"
application.register("hotkey-submit", HotkeySubmitController)

import HwComboboxController from "./hw_combobox_controller"
application.register("hw-combobox", HwComboboxController)

import IconPickerController from "./icon_picker_controller"
application.register("icon-picker", IconPickerController)

import ImageCropController from "./image_crop_controller"
application.register("image-crop", ImageCropController)

import ImageUploadsController from "./image_uploads_controller"
application.register("image-uploads", ImageUploadsController)

import InboxActionsController from "./inbox_actions_controller"
application.register("inbox-actions", InboxActionsController)

import InboxFocusController from "./inbox_focus_controller"
application.register("inbox-focus", InboxFocusController)

import InboxTabsController from "./inbox_tabs_controller"
application.register("inbox-tabs", InboxTabsController)

import InlineFieldCreatorController from "./inline_field_creator_controller"
application.register("inline-field-creator", InlineFieldCreatorController)

import KeyboardShortcutRegistryController from "./keyboard_shortcut_registry_controller"
application.register("keyboard-shortcut-registry", KeyboardShortcutRegistryController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LineChartController from "./line_chart_controller"
application.register("line-chart", LineChartController)

import LinkableController from "./linkable_controller"
application.register("linkable", LinkableController)

import LocalTimeController from "../../view_components/stoked/local_time_controller"
application.register("local-time", LocalTimeController)

import MapMemoryController from "./map_memory_controller"
application.register("map-memory", MapMemoryController)

import NearbyMapComponentController from "../../view_components/community_site/nearby_map_component_controller"
application.register("nearby-map-component", NearbyMapComponentController)

import OtpFieldController from "./otp_field_controller"
application.register("otp-field", OtpFieldController)

import PersistTabController from "./persist_tab_controller"
application.register("persist-tab", PersistTabController)

import PhoneCountryController from "./phone_country_controller"
application.register("phone-country", PhoneCountryController)

import PhoneLookupController from "./phone_lookup_controller"
application.register("phone-lookup", PhoneLookupController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PlaceSearchController from "./place_search_controller"
application.register("place-search", PlaceSearchController)

import QuestionOptionsController from "./question_options_controller"
application.register("question-options", QuestionOptionsController)

import QuickReplyPickerController from "./quick_reply_picker_controller"
application.register("quick-reply-picker", QuickReplyPickerController)

import RegionSelectController from "./region_select_controller"
application.register("region-select", RegionSelectController)

import SearchInputController from "./search_input_controller"
application.register("search-input", SearchInputController)

import SearchTokensController from "./search_tokens_controller"
application.register("search-tokens", SearchTokensController)

import SendMessageStartedController from "./send_message_started_controller"
application.register("send-message-started", SendMessageStartedController)

import SendMessageStepsController from "./send_message_steps_controller"
application.register("send-message-steps", SendMessageStepsController)

import SettingsNavController from "./settings_nav_controller"
application.register("settings-nav", SettingsNavController)

import SiteFilterDropdownController from "./site_filter_dropdown_controller"
application.register("site-filter-dropdown", SiteFilterDropdownController)

import SmsEstimateController from "./sms_estimate_controller"
application.register("sms-estimate", SmsEstimateController)

import StepperController from "./stepper_controller"
application.register("stepper", StepperController)

import SvgUploadController from "./svg_upload_controller"
application.register("svg-upload", SvgUploadController)

import TemplateLockToggleController from "./template_lock_toggle_controller"
application.register("template-lock-toggle", TemplateLockToggleController)

import TextareaAutosizeController from "./textarea_autosize_controller"
application.register("textarea-autosize", TextareaAutosizeController)

import ToastController from "../../view_components/ui/toast_controller"
application.register("toast", ToastController)

import WalletActionsController from "./wallet_actions_controller"
application.register("wallet-actions", WalletActionsController)

import WidgetConfiguratorController from "./widget_configurator_controller"
application.register("widget-configurator", WidgetConfiguratorController)

// Code-split controllers: their modules (and large deps like TipTap and
// OpenLayers) load only when an element using them appears in the DOM.
// Edit LAZY_CONTROLLER_TAGS in lib/tasks/stimulus_tasks.rake to change this set.
registerLazyControllers(application, {
  "advocate-map-component": () => import("../../view_components/stoked/advocate_map_component_controller"),
  "location-picker": () => import("../../view_components/ui/form/location_picker_controller"),
  "tiptap-input": () => import("../../view_components/ui/form/tiptap_input_controller"),
})
